
import { supabase } from '@/lib/supabase/client';
import { toast } from '@/hooks/use-toast';

/**
 * Déclenche la fonction edge pour synchroniser les commentaires YouTube d'un profil
 * @param profileId ID du profil social YouTube
 * @returns Un objet indiquant le succès ou l'échec de l'opération
 */
export const syncYouTubeComments = async (profileId: string): Promise<{success: boolean, message: string}> => {
  try {
    console.log(`Démarrage de la synchronisation des commentaires pour le profil ${profileId}`);
    
    // Appel de la fonction edge Supabase pour synchroniser les commentaires
    const { data, error } = await supabase.functions.invoke('fetch_youtube_comments_new', {
      body: { profileId },
    });
    
    if (error) {
      console.error('Erreur lors de la synchronisation des commentaires YouTube:', error);
      toast({
        title: "Erreur de synchronisation",
        description: `Impossible de synchroniser les commentaires: ${error.message || 'Erreur inconnue'}`,
        variant: "destructive",
      });
      return { 
        success: false, 
        message: `Erreur lors de la synchronisation: ${error.message || 'Erreur inconnue'}` 
      };
    }
    
    const message = data?.message || 'Commentaires synchronisés avec succès';
    toast({
      title: "Synchronisation réussie",
      description: message,
    });
    
    console.log('Résultat de la synchronisation des commentaires:', data);
    return { success: true, message };
  } catch (error) {
    console.error('Exception lors de la synchronisation des commentaires YouTube:', error);
    toast({
      title: "Erreur de synchronisation",
      description: error instanceof Error ? error.message : 'Erreur inconnue lors de la synchronisation',
      variant: "destructive",
    });
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Erreur inconnue lors de la synchronisation'
    };
  }
};

/**
 * Analyse un commentaire avec l'IA et génère une réponse
 * @param commentId ID du commentaire à analyser
 * @returns Un objet indiquant le succès ou l'échec de l'opération
 */
export const analyzeCommentWithAI = async (commentId: string): Promise<{success: boolean, message: string, data?: any}> => {
  try {
    console.log(`Démarrage de l'analyse du commentaire ${commentId}`);
    
    // Appel de la fonction edge Supabase pour analyser le commentaire
    const { data, error } = await supabase.functions.invoke('analyze_and_generate_reply', {
      body: { comment_id: commentId },
    });
    
    if (error) {
      console.error('Erreur lors de l\'analyse du commentaire:', error);
      return { 
        success: false, 
        message: `Erreur lors de l'analyse: ${error.message || 'Erreur inconnue'}` 
      };
    }
    
    console.log('Résultat de l\'analyse du commentaire:', data);
    return { 
      success: true, 
      message: 'Commentaire analysé avec succès',
      data
    };
  } catch (error) {
    console.error('Exception lors de l\'analyse du commentaire:', error);
    return { 
      success: false, 
      message: error instanceof Error ? error.message : 'Erreur inconnue lors de l\'analyse'
    };
  }
};
